import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { ErrorHandleService } from './error-handle.service';
import { catchError, Observable } from 'rxjs';
import { ChangePassword, ChangePasswordResponse } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private apiUrl = `${environment.APIDEV}`;

  constructor(
    private http: HttpClient,
    private errorHandle: ErrorHandleService
  ) { }


  changePassword(passwordData: ChangePassword): Observable<ChangePasswordResponse> {
    return this.http.post<ChangePasswordResponse>(`${this.apiUrl}change_password`, passwordData, {
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }
}
